<template>
  <v-select
    v-model="model"
    :items="additives"
    :label="$t('menuAdditives')"
    :menu-props="{
      'offset-y': true,
    }"
    :no-data-text="$t('menuAdditivesNoDataText')"
    class="grow-1"
    dense
    item-text="index"
    item-value="id"
    multiple
    return-object
  >
    <!-- Create MenuAdditive -->
    <template slot="prepend-item">
      <v-list-tile
        class="mt-1"
        :class="[isAdditiveNameUnique(newAdditiveName) ? 'mb-1' : 'mb-3']"
      >
        <v-layout align-center>
          <v-text-field
            v-model="newAdditiveName"
            :rules="[rules.uniqueAdditiveName]"
            clearable
            :placeholder="$t('menuAdditivesCreateDialogTitle')"
            @click:clear="newAdditiveName = ''"
            @keyup.enter="createMenuAdditiveFor(selection)"
          />
          <v-btn
            small
            round
            :dark="newAdditiveNameIsValid"
            :title="$t('add')"
            icon
            :color="!!newAdditiveName ? 'success' : 'grey'"
            class="ml-2 mr-0 my-0"
            :disabled="!newAdditiveNameIsValid"
            @click="createMenuAdditiveFor(selection)"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-layout>
      </v-list-tile>
    </template>
    <!-- Select MenuAdditives -->
    <template
      slot="item"
      slot-scope="data"
    >
      <v-list-tile-action style="min-width: 36px">
        <v-checkbox
          v-model="data.tile.props.value"
          color="msr"
          hide-details
        />
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          {{ data.item.name }}
          <span class="grey--text">({{ data.item.index }})</span>
        </v-list-tile-title>
      </v-list-tile-content>
    </template>
    <!-- Go to MenuAdditives -->
    <template slot="append-item">
      <v-layout>
        <div
          class="ml-auto pr-3 pt-2 pseudo-anchor grey--text text--darken-1"
          style="font-size: small"
          @click="
            $router.push({
              name: 'menuadditives',
              params: {menuId: menuId},
            })
          "
        >
          {{ $t('goToMenuAdditives') }}
        </div>
      </v-layout>
    </template>
  </v-select>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {
    menuId: {
      type: [Number, String],
      required: true,
    },
    /**
     * MenuAdditives that we can select from.
     */
    additives: {
      type: Array[Object],
      required: true,
    },
    /**
     * We are changing this by de/selecting items within the dropdown.
     */
    selection: {
      type: Array[Object],
      required: true,
    },
  },
  data() {
    return {
      newAdditiveName: '',
    };
  },
  computed: {
    model: {
      get() {
        return this.selection;
      },
      set(selectedAdditives) {
        this.$emit('update:selection', selectedAdditives);
      },
    },
    rules() {
      return {
        uniqueAdditiveName: (v) =>
          this.isAdditiveNameUnique(v) || this.$t('nameAlreadyInUse'),
      };
    },
    newAdditiveNameIsValid() {
      return (
        !!this.newAdditiveName &&
        this.newAdditiveName.trim() != '' &&
        this.isAdditiveNameUnique(this.newAdditiveName)
      );
    },
  },
  methods: {
    isAdditiveNameUnique(name) {
      if (!name || name.trim() == '') {
        return true;
      }

      return !this.additives
        .map((additive) => additive.name.toLowerCase())
        .includes(name.trim().toLowerCase());
    },
    createMenuAdditiveFor(additives = null) {
      if (!this.newAdditiveNameIsValid) {
        return;
      }

      this.$api
        .createMenuAdditive(this.menuId, this.newAdditiveName)
        .then((response) => {
          const additive = response.data;

          // Frontend update
          if (additives) {
            additives.push(additive);
          }

          // Reset
          this.newAdditiveName = '';

          this.$emit('additive-created', additive);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Menu/AdditivesSelect.vue